<div class="w-100 mb-2 generic-info hip"
     fxLayout="row"
     fxLayout.xs="column"
     fxLayoutAlign="space-between center"
     *ngIf="header">
  <div ngClass.xs="w-100"
       class="hip__title">
    <h1 *ngIf="header.title"
        class="w-100 generic-info__title"
        [innerHTML]="safeHtmlTitle"></h1>
    <span *ngIf="header.text"
          class="w-100 generic-info__text"
          [innerHTML]="safeHtmlText"></span>
  </div>
  <div ngClass.xs="w-100 mt-2 mb-2"
       class="hip__content">
    <ng-content></ng-content>
  </div>
</div>
